import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
  data: null,
  error: '',
  isEditingWelcomeMessage: false,
  isEditingSpeedFormation: false,
  speedFormationDate: null,
  welcomeMessageSave: {
    isLoading: false,
    error: null,
    errorMessage: null,
  },
  speedFormationSave: {
    isLoading: false,
    error: null,
    errorMessage: null,
  },
}

const updateHomeIsLoadingHandler = (state, action) => {
  state.isLoading = action.payload
}

const updateHomeDataHandler = (state, action) => {
  state.data = action.payload
}

const updateHomeErrorHandler = (state, action) => {
  state.error = action.payload
}

const setIsEditingWelcomeMessageHandler = (state, action) => {
  state.isEditingWelcomeMessage = action.payload
}

const setIsEditingSpeedFormationHandler = (state, action) => {
  state.isEditingSpeedFormation = action.payload
}

const setSpeedFormationDateHandler = (state, action) => {
  state.speedFormationDate = action.payload
}

const updateWelcomeMessageSaveStatusHandler = (state, action) => {
  state.welcomeMessageSave = action.payload
}

const updateSpeedFormationSaveStatusHandler = (state, action) => {
  state.speedFormationSave = action.payload
}

export const HomeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    updateHomeIsLoading: updateHomeIsLoadingHandler,
    updateHomeData: updateHomeDataHandler,
    updateHomeError: updateHomeErrorHandler,
    setIsEditingWelcomeMessage: setIsEditingWelcomeMessageHandler,
    setIsEditingSpeedFormation: setIsEditingSpeedFormationHandler,
    setSpeedFormationDate: setSpeedFormationDateHandler,
    updateWelcomeMessageSaveStatus: updateWelcomeMessageSaveStatusHandler,
    updateSpeedFormationSaveStatus: updateSpeedFormationSaveStatusHandler,
    clearHome: () => initialState,
  },
})

export const {
  updateHomeIsLoading,
  updateHomeData,
  updateHomeError,
  setIsEditingWelcomeMessage,
  setIsEditingSpeedFormation,
  setSpeedFormationDate,
  updateWelcomeMessageSaveStatus,
  updateSpeedFormationSaveStatus,
  clearHome,
} = HomeSlice.actions

export default HomeSlice.reducer
